__turbopack_context__.v({
  "border-bottom": "index-module__V4ClkW__border-bottom",
  "center": "index-module__V4ClkW__center",
  "clean": "index-module__V4ClkW__clean",
  "dark": "index-module__V4ClkW__dark",
  "editable": "index-module__V4ClkW__editable",
  "element": "index-module__V4ClkW__element",
  "hasIcon": "index-module__V4ClkW__hasIcon",
  "light": "index-module__V4ClkW__light",
  "outline": "index-module__V4ClkW__outline",
  "removeControls": "index-module__V4ClkW__removeControls",
  "right": "index-module__V4ClkW__right",
  "small": "index-module__V4ClkW__small",
  "solid": "index-module__V4ClkW__solid",
});
